import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../NosValeurs.css";
import qualite from "../../assets/qualite.png";
import sensibilisation from "../../assets/Sensibilisation.png";
import equipement from "../../assets/equipement.png";
import protocole from "../../assets/Protocole.png";
import ressources from "../../assets/ressources.png";
import formation from "../../assets/Formation.png";
import carriere from "../../assets/carriere.png";
import biodiversite from "../../assets/biodiversite.png";
import carbone from "../../assets/carbone.png";

const NosValeurs = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  const sections = [
    {
      id: "collaborateurs",
      title: "Nos collaborateurs, notre force",
      items: [
        { image: formation, description: "Formation continue de 40h/an, certification pro" },
        { image: qualite, description: "Qualité de vie, équipement ergonomique, avantages sociaux" },
        { image: carriere, description: "Évolution de carrière, promotion interne" },
      ],
    },
    {
      id: "securite",
      title: "La sécurité, notre priorité",
      items: [
        { image: sensibilisation, description: "Sensibilisation aux risques, exercices pratiques" },
        { image: equipement, description: "Équipement de protection, contrôle quotidien" },
        { image: protocole, description: "Protocole de sécurité, procédures d'urgence" },
      ],
    },
    {
      id: "environnement",
      title: "L'environnement, notre solution",
      items: [
        { image: ressources, description: "Gestion de ressources, tri sur chaque chantier" },
        { image: carbone, description: "Réduction de l'impact carbone, optimisation des déplacements" },
        { image: biodiversite, description: "Protection de la biodiversité, re-végétalisation" },
      ],
    },
  ];

  return (
    <div className="nos-valeurs">
      {sections.map((section, index) => (
        <div key={index} id={section.id} className="section">
          <h2 className="section-title">{section.title}</h2>
          <div className="section-content">
            {section.items.map((item, idx) => (
              <div key={idx} className="section-item">
                <img src={item.image} alt={item.description} className="item-image" />
                <p className="item-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NosValeurs;
